// client/src/lib/format.js
// Hebrew/IL-friendly formatting helpers. Centralized so a future change to
// the locale (e.g. supporting an English UI) hits one file.

// CLAUDE.md requires DD/MM/YYYY HH:MM in Asia/Jerusalem. Using en-GB instead
// of he-IL because he-IL on most engines renders dots (18.05.2026), and en-GB
// reliably produces the slashed form the spec calls for.
const DATE_FMT = new Intl.DateTimeFormat('en-GB', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  timeZone: 'Asia/Jerusalem',
});

const DATETIME_FMT = new Intl.DateTimeFormat('en-GB', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
  timeZone: 'Asia/Jerusalem',
});

export function formatDate(d) {
  if (!d) return '—';
  const date = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(date.getTime())) return '—';
  return DATE_FMT.format(date);
}

export function formatDateTime(d) {
  if (!d) return '—';
  const date = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(date.getTime())) return '—';
  // en-GB inserts a comma between date and time ("18/05/2026, 14:30").
  // CLAUDE.md wants a plain space, so strip it.
  return DATETIME_FMT.format(date).replace(', ', ' ');
}

/**
 * "₪47" style. Pass null/undefined to get "—".
 * Second arg is the currency code from the camp (SHEKEL / DOLLAR / STAR);
 * omitted = SHEKEL for backwards compatibility with the few call sites
 * that haven't been threaded with currency yet.
 *
 * Prefer formatAmount from lib/currency.js for new code — this is kept
 * as a back-compat alias so old call sites keep rendering.
 */
import { formatAmount } from './currency.js';
export function formatMoney(n, currencyCode) {
  return formatAmount(n, currencyCode);
}
